<template>
    <div>
        <b-row class="text-muted ml-0">Desglose Tarifa</b-row>
        <div class="d-flex align-items-center">
            <!--internet-->
            <div class="d-flex align-items-center">
                <b-avatar variant="light-primary" rounded>
                    <feather-icon icon="WifiIcon" size="13" />
                </b-avatar>
                <div class="ml-1">
                    <h4 class="mb-0">{{ data.tarifa_in }}</h4>
                </div>
            </div>
            <!--tv-->
            <div class="d-flex align-items-center ml-1">
                <b-avatar variant="light-success" rounded>
                    <feather-icon icon="TvIcon" size="13" />
                </b-avatar>
                <div class="ml-1">
                    <h4 class="mb-0">{{ data.tarifa_tv }}</h4>
                </div>
            </div>
            <!--tv-->
            <div class="d-flex align-items-center ml-1">
                <b-avatar variant="light-danger" rounded>
                    <feather-icon icon="DollarSignIcon" size="13" />
                </b-avatar>
                <div class="ml-1">
                    <h4 class="mb-0">{{ data.tarifa }}</h4>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { BRow, BAvatar } from "bootstrap-vue";

export default {
    components: {
        BAvatar,
        BRow,
    },
    data() {
        return {
            show: true,
        };
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    created() {},
    methods: {},
};
</script>

<style></style>
